var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalineAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4C5.75 3.30964 6.30964 2.75 7 2.75H13.337C13.6187 3.94259 14.5574 4.88132 15.75 5.16303V6.98507H14C13.1743 6.98507 12.4655 7.47296 12.1602 8.16922H20.8398C20.5345 7.47296 19.8257 6.98507 19 6.98507H17.25V5.16303C18.6834 4.82445 19.75 3.53679 19.75 2C19.75 1.58579 19.4142 1.25 19 1.25C18.5858 1.25 18.25 1.58579 18.25 2C18.25 2.9665 17.4665 3.75 16.5 3.75C15.5335 3.75 14.75 2.9665 14.75 2C14.75 1.58579 14.4142 1.25 14 1.25H7C5.48122 1.25 4.25 2.48122 4.25 4V22C4.25 22.4142 4.58579 22.75 5 22.75C5.41421 22.75 5.75 22.4142 5.75 22V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.6319V12.0946H17.7856C17.3714 12.0946 17.0356 12.422 17.0356 12.8259C17.0356 13.2298 17.3714 13.5573 17.7856 13.5573H21V14.9751H19.0715C18.6573 14.9751 18.3215 15.3025 18.3215 15.7064C18.3215 16.1103 18.6573 16.4378 19.0715 16.4378H21V16.9908C21 17.4468 20.69 17.8476 20.2404 17.9728C19.8306 18.087 19.4167 18.182 19 18.2579V18.7015C19 19.24 18.5523 19.6766 18 19.6766H17.25V20.2687C17.25 20.6726 16.9142 21 16.5 21C16.0858 21 15.75 20.6726 15.75 20.2687V19.6766H15C14.4477 19.6766 14 19.24 14 18.7015V18.2579C13.5833 18.182 13.1694 18.087 12.7596 17.9728C12.31 17.8476 12 17.4468 12 16.9908V9.6319H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalineAlt1);
export default __webpack_public_path__ + "static/media/saline-alt-1.ed1261023cbdccee7e33462556f43a0d.svg";
export { ForwardRef as ReactComponent };